import zappy from '@zappy-ride/library.react.components';

import { InputWithToggleCheckbox } from './InputWithToggleCheckbox';

export * from './InputWithToggleCheckbox';

zappy.FactoryInstance.registerComponent(InputWithToggleCheckbox);
